import { render, staticRenderFns } from "./DashboardProductos.vue?vue&type=template&id=824dfbc4&scoped=true&"
import script from "./DashboardProductos.vue?vue&type=script&lang=js&"
export * from "./DashboardProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824dfbc4",
  null
  
)

export default component.exports